import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
    parse(value: string): NgbDateStruct | null {
        if (!value) {
            return null;
        }

        const normalized = value.trim().replace(/-/g, '/');
        const dateParts = normalized.split('/');

        if (dateParts.length === 1 && isNumber(dateParts[0])) {
            return {
                day: toInteger(dateParts[0]),
                month: 0,
                year: 0
            };
        }

        if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
            return {
                day: toInteger(dateParts[0]),
                month: toInteger(dateParts[1]),
                year: 0
            };
        }

        if (
            dateParts.length === 3 &&
            isNumber(dateParts[0]) &&
            isNumber(dateParts[1]) &&
            isNumber(dateParts[2])
        ) {
            return {
                day: toInteger(dateParts[0]),
                month: toInteger(dateParts[1]),
                year: toInteger(dateParts[2])
            };
        }

        return null;
    }

    format(date: NgbDateStruct | null): string {
        return date
            ? `${isNumber(date.day) ? padNumber(date.day) : ''}/${isNumber(date.month) ? padNumber(date.month) : ''}/${date.year || ''}`
            : '';
    }
}

export function toInteger(value: any): number {
    return parseInt(`${value}`, 10);
}

export function isNumber(value: any): boolean {
    return value !== null && value !== undefined && value !== '' && !isNaN(toInteger(value));
}

export function padNumber(value: number): string {
    return isNumber(value) ? `0${value}`.slice(-2) : '';
}